import { RootState } from '../root.reducers';
import { NatConfiguration } from './natConfiguration.types';

export const getNatConfigurationList = (state: RootState): NatConfiguration[] =>
  state.natConfiguration.entities;

export const getNatConfiguration = (state: RootState): NatConfiguration | null =>
  state.natConfiguration.single;

export const getSelectedNatConfiguration = (state: RootState): NatConfiguration[] =>
  state.natConfiguration.selected;

export const getNatConfigurationCreatedId = (state: RootState): string | null =>
  state.natConfiguration.createdId;

export const isNatConfigurationCreatePopupOpen = (state: RootState): boolean =>
  state.natConfiguration.ui.isCreatePopupOpen;

export const isNatConfigurationLoading = (state: RootState): boolean =>
  state.natConfiguration.ui.isLoading;
